export default "/images/global.avif?8cb989c57b25d3fbedfaa2611c5d6787";